import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-doc-check-handler',
  templateUrl: './doc-check-handler.component.html',
  styleUrls: ['./doc-check-handler.component.scss']
})
export class DocCheckHandlerComponent implements OnInit {

  constructor(
    private _router: Router
    ) { }

  ngOnInit(): void {
  }

}
